export default [
	{
		path: '/nueva_propuesta',
		name: 'nueva_propuesta',
		props: true,
		component: () => import(/* webpackChunkName: "compras" */ '../views/Propuesta.vue')
	},
	{
		path: '/gestionar_propuestas',
		name: 'gestionar_propuestas',
		props: true,
		component: () => import(/* webpackChunkName: "compras" */ '../views/GestionarPropuestas.vue')
	},
	{
		path: '/dashboard_compras',
		name: 'dashboard_compras',
		props: true,
		component: () => import(/* webpackChunkName: "compras" */ '../views/DashboardCompras.vue')
	},
	{
		path: '/gestionar_propuestas_compras/:id?',
		name: 'gestionar_propuestas_compras',
		props: true,
		component: () => import(/* webpackChunkName: "compras" */ '../views/GestionarPropuestasCompras.vue')
	},
	{
		path: '/propuestas_pedido/:id',
		name: 'propuestas_pedido',
		props: true,
		component: () => import(/* webpackChunkName: "compras" */ '../views/PropuestaHistorica.vue')
	},
	{
		path: '/reservas_barco/:id',
		name: 'reservas_barco',
		props: true,
		component: () => import(/* webpackChunkName: "compras" */ '../views/ReservasBarco.vue')
	}
]
